import localData from "site/common/localData";

/*eslint-disable */
define(function(require) {
    var $ = require('jquery');

    return {
        restore: function($parent) {
            if (!Modernizr.localstorage) {
                return;
            }

            $parent.find('.persistent-field').each(function() {
                var $field = $(this);
                var name = $field.data('persist-name') || $field.attr('name');
                var value = localData.getItem(name);

                if (!value) {
                    return;
                }

                if(!$field.val() || $field.val().length <= 0) {
                    $field.val(value);
                    if (this.tagName === 'SELECT') {
                        $field.change();
                    }
                }
            });
        },

        saveField: function(field) {
            if (!Modernizr.localstorage) {
                return;
            }

            var $element = $(field);
            var name     = $element.data('persist-name') || $element.attr('name');
            var value    = $element.val();

            localData.setItem(name, value);
        }
    };
});
